import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * Platform-agnostic television shell for the TV preview variants — the
 * counterpart to {@link MobileFrameComponent} and {@link DesktopFrameComponent}.
 * Draws the set's bezel, its indicator light and its stand, and clips whatever
 * it wraps at the screen edge.
 *
 * Unlike the browser window, which keeps a fixed height and only narrows with
 * the preview pane, a television is 16:9 whatever its size, so the screen holds
 * its ratio and the picture inside scales with it — which is how the TV app
 * itself behaves on a smaller set.
 */
@Component({
  selector: 'app-tv-frame',
  standalone: true,
  templateUrl: './tv-frame.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tv-frame.component.scss',
})
export class TvFrameComponent {}
